import type { FC } from 'react';
import { useState } from 'react';
import { useRouter } from 'next/router';

import { ListItemIcon, ListItemText, MenuItem, MenuList } from '@packages/shared';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { SeoProductCategoryNavigationFragmentFragmentDoc } from '@packages/gql/generated/shopping/SeoProductCategoryNavigationFragmentFragmentDoc';
import { ArrowMediumDown32, ArrowMediumRight32 } from '@packages/themes/dist/icons';

/* GraphQL */ `
  fragment SeoProductCategoryNavigationFragment on SeoCategoryNavigation {
    title
    items {
      id
      name
      pathName
    }
  }
`;

export type SeoProductCategoryNavigationProps = {
  maskedNavigation: FragmentType<typeof SeoProductCategoryNavigationFragmentFragmentDoc>;
};

/**
 * Displays the given seo category navigation under the "normal" MBA category navigation.
 * */
export const SeoProductCategoryNavigation: FC<SeoProductCategoryNavigationProps> = ({
  maskedNavigation,
}) => {
  const [open, setOpen] = useState(false);
  const { push } = useRouter();

  const navigation = getFragmentData(
    SeoProductCategoryNavigationFragmentFragmentDoc,
    maskedNavigation,
  );

  return (
    <MenuList sx={{ paddingTop: 0 }}>
      <MenuItem sx={{ paddingLeft: 1 }} onClick={() => setOpen(!open)}>
        <ListItemText
          primaryTypographyProps={{
            sx: { overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' },
          }}
        >
          {navigation.title}
        </ListItemText>
        <ListItemIcon>{open ? <ArrowMediumDown32 /> : <ArrowMediumRight32 />}</ListItemIcon>
      </MenuItem>
      {open &&
        navigation.items.map((item) => (
          <MenuItem key={item.id} onClick={() => push(item.pathName)}>
            {item.name}
          </MenuItem>
        ))}
    </MenuList>
  );
};
